import styled from "styled-components";
// Children Component
export const Children = styled.div`
 width: 100%;
 height: 100%;
 margin-left: ${({ displaySidebar }) => (displaySidebar ? "12%" : "12%")};
 @media (max-width: 670px) {
 margin-left: 5rem;
 }
`;
export const SidebarWrapper = styled.div`
 width: 100%;
 height: 100%;
 display: flex;
 flex-direction: column;
 font-size: 0.9rem;
 @media (max-width: 1200px) {
 font-size: 35%;
 }
`;
export const SidebarLogoWrapper = styled.div`
 padding: 2% 4%;
 margin-bottom: 1rem;
 display: flex;
 justify-content: ${({ displaySidebar }) =>
 displaySidebar ? "space-between" : "center"};
 align-items: center;
 @media (max-width: 670px) {
 justify-content: center;
 }
`;
export const SidebarLogo = styled.a`
 display: flex;
 align-items: center;
 justify-content: center;
`;
export const SidebarBrand = styled.span`
 display: ${({ displaySidebar }) => (displaySidebar ? "block" : "none")};
`;
export const SidebarToggler = styled.button`
 cursor: pointer;
 display: ${({ displaySidebar }) => (displaySidebar ? "block" : "none")};
 @media (max-width: 670px) {
 display: block;
 }
`;
// SidebarItem styles
export const ItemsList = styled.ul`
 list-style: none;
 padding: 0px;
`;
export const ItemWrapper = styled.div`
    transition: .3s;
    display: flex;
    align-items: center;
    color: #7c7788;
    cursor: pointer;

    &:hover{
        color: #F0B6D5;
    }
`;
export const ItemContainer = styled.li`
  margin-top: 0.5rem;
  width: 100%;
  padding: ${({ isSmallScreen }) => (isSmallScreen ? "0.25rem" : "0.5rem")} ${({ isSmallScreen }) => (isSmallScreen ? "0.125rem" : "0.25rem")};
  border-radius: 0.2rem;

  background-color: transparent;
  transition: background-color .3s;

  &.active {
    background-color: #F0B6D520;
  }

  &.active ${ItemWrapper} {
    color: #F0B6D5;
  }

  a:focus-visible {
    outline: 2px solid #F0B6D5;
    border-radius: 2px;
  }

  a {
    display: block;
    color: inherit;
    text-decoration: none;
  }

  a:hover,
  a:focus,
  a:visited,
  a:active {
    color: inherit;
    text-decoration: none;
  }
`;
export const ItemName = styled.span`
 margin-left: ${({ displaySidebar }) => (displaySidebar ? "0.5rem" : "0")};
`;
// Sidebar Container
export const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${({ displaySidebar }) => (displaySidebar ? "12%" : "12%")};
  height: 100dvh;
  padding: 0.75rem;
  box-sizing: border-box;
  overflow: hidden;
    background: ${({ isHomePage }) =>
    isHomePage ? "transparent" : "#232323"};

  transition:
  width 500ms cubic-bezier(0.25, 1, 0.5, 1),
  background-color 400ms ease,
  box-shadow 400ms ease;
  backdrop-filter: blur(8px);
  ${({ displaySidebar }) =>
  displaySidebar && "box-shadow: 4px 0px 8px 0px rgba(0,0,0,0.1)"};
  ${ItemWrapper} {
  justify-content: ${({ displaySidebar }) => !displaySidebar && "center"};
  }
  &:hover {
  ${({ displaySidebar }) =>
  !displaySidebar && "box-shadow: 8px 0px 12px 0px rgba(0,0,0,0.1)"};
  @media (min-width: 468px) {
  width: ${({ displaySidebar }) => !displaySidebar && "12%"};
  ${SidebarLogoWrapper} {
  justify-content: ${({ displaySidebar }) =>
  !displaySidebar && "space-between"};
  }
  ${SidebarBrand} {
  display: ${({ displaySidebar }) => !displaySidebar && "block"};
  }
  ${SidebarToggler} {
  display: ${({ displaySidebar }) => !displaySidebar && "block"};
  }
  ${ItemWrapper} {
  justify-content: ${({ displaySidebar }) =>
  !displaySidebar && "flex-start"};
  }
  ${ItemName} {
  display: ${({ displaySidebar }) => !displaySidebar && "block"};
  margin-left: ${({ displaySidebar }) => !displaySidebar && "0.5rem"};
  }
  }
  }
  ::-webkit-scrollbar {
  width: 4px;
  height: 3px;
  }
  ::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #eaeced;
  &:hover {
  background: #d5e0f3;
  }
  }
  @media (max-width: 670px) {
    width: 5rem;
    padding: 0.5rem;
  }
  `;